export const settingsRoutes = [
	// NOTE: Hiding these pages/routes until further notice
	// {
	// 	label: "Attributes",
	// 	path: "/settings/attributes",
	// 	global: true,
	// 	nonGlobal: false,
	// 	adminOnly: true
	// },
	// {
	// 	label: "Asset Types",
	// 	path: "/settings/assetTypes",
	// 	global: true,
	// 	nonGlobal: false,
	// 	adminOnly: true
	// },
	{
        label: "Users",
        path: "/settings/users",
        global: true,
        nonGlobal: true,
        adminOnly: true
    },
	{
		label: "Configuration",
		path: "/settings/configuration",
		global: false,
		nonGlobal: true,
		adminOnly: false
	},
	{
        label: "Import",
        path: "/settings/import",
        global: true,
        nonGlobal: true,
        adminOnly: true
    },
	{
        label: "Tenants",
        path: "/settings/tenants",
        global: true,
        nonGlobal: false,
        adminOnly: true
    }
];
